import { createSlice } from '@reduxjs/toolkit';

/*
|-----------------------------------------------------------------
| Initial State
|-----------------------------------------------------------------
|
*/

interface ILayoutState {
  isDownloadAppModalOpened: boolean;
}

const initialState: ILayoutState = {
  isDownloadAppModalOpened: false
};

/*
|-----------------------------------------------------------------
| Create Slice
|-----------------------------------------------------------------
|
*/

const layoutState = createSlice({
  name: 'layoutState',
  initialState,
  reducers: {
    openDownloadAppModal(state) {
      state.isDownloadAppModalOpened = true;
    },
    closeDownloadAppModal(state) {
      state.isDownloadAppModalOpened = false;
    }
  }
});

/*
|-----------------------------------------------------------------
| Export actions & reducer
|-----------------------------------------------------------------
|
*/
export const layoutActions = layoutState.actions;
export { default as layoutSelectors } from './layout.selectors';

export default layoutState.reducer;
